import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

export default function AlertDialog({
  open,
  handleClose,
  message = "",
  heading = "",
  isLoading = false,
}) {
  const {t} = useTranslation();
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => handleClose("cancel")}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-blue-600">
          {heading}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => handleClose("cancel")}
            autoFocus
            disabled={isLoading}
            className={`px-4 py-1 bg-white text-[red] rounded-md border border-[red] text-[14px] ${
              isLoading && "opacity-[0.7] pointer-events-none"
            }`}
          >
            {t(`firstFormSteps.confirmAdvisebuttonCancelText`)}
          </button>

          <button
            onClick={() => handleClose("confirm")}
            autoFocus
            disabled={isLoading}
            className={`px-4 py-1 bg-blue-600 text-white rounded-md border border-blue-600 text-[14px] ${
              isLoading
                ? "opacity-[0.7] pointer-events-none"
                : "hover:bg-white hover:text-[#0575E6]"
            }`}
          >
             {t(`firstFormSteps.confirmAdvisebuttonText`)}
          </button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
